import styled from '@emotion/styled';

const OverviewContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 500px;
  padding: 8px;
  background-color: ${({ theme }) => theme.backgroundColor};
  font-family: ${({ theme }) => theme.fontFamily};
`;

export default OverviewContainer;
